// assets
import { IconUser, IconWorldWww, IconPlus, IconBuilding } from '@tabler/icons';

// constant
const icons = { IconUser, IconWorldWww, IconPlus, IconBuilding };

// ==============================|| CONFIGS MENU ITEMS ||============================== //

const configs = {
  id: 'configs',
  title: 'Configurações',
  type: 'group',
  children: [
    {
      id: 'sites-view',
      title: 'Sites',
      type: 'collapse',
      url: 'sites',
      icon: icons.IconWorldWww,
      breadcrumbs: true,
      children: [
        {
          id: 'sites-view',
          title: 'Sites',
          type: 'item',
          url: 'sites',
          icon: icons.IconWorldWww,
          breadcrumbs: true
        },
        {
          id: 'sites-create',
          title: 'Novo site',
          type: 'item',
          url: 'sites/add',
          icon: icons.IconPlus,
          breadcrumbs: true
        }
      ]
    },
    {
      id: 'users-view',
      title: 'Usuários',
      type: 'item',
      url: 'users',
      icon: icons.IconUser,
      breadcrumbs: true
    },
    {
      id: 'companies-view',
      title: 'Organização',
      type: 'item',
      url: 'company',
      icon: icons.IconBuilding,
      breadcrumbs: true
    }
  ]
};

export default configs;
